import { accordion } from "./functions/accordion";
import { gnav } from "./functions/gnav";

export default class CommonFunction {
    constructor(scrollfunc) {
        this.init(scrollfunc);
    }

    init(scrollfunc) {
        accordion(scrollfunc);
        gnav();
    }
}
